import { dragScroll } from "~/directives/dragScroll";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("drag-scroll", dragScroll);
});
